/**
 * Source of wealth options (matches Flutter UserSourceOfWealth).
 */

export const SOURCE_OF_WEALTH = {
  EMPLOYMENT_OR_BUSINESS_PROCEEDS: 0,
  SAVINGS_OR_INVESTMENTS: 1,
  GIFTS_OR_INHERITANCE: 2,
  OTHER: 3,
  DIGITAL_WALLET: 4,
};

export const SOURCE_OF_WEALTH_OPTIONS = [
  { value: 0, label: 'Employment or business proceeds' },
  { value: 1, label: 'Savings or investments' },
  { value: 2, label: 'Gifts or inheritance' },
  { value: 3, label: 'Other' },
  { value: 4, label: 'Digital wallet' },
];

export function labelForSourceOfWealth(value) {
  const o = SOURCE_OF_WEALTH_OPTIONS.find((x) => x.value === value);
  return o ? o.label : 'Unknown';
}
